import { useLocation } from "@tanstack/react-router"
import { useEffect, useRef, useState } from "react"
import { CardTitle } from "@/components/ui/card"
import { authorizeUrl, OAUTH_CONTINUE_PATH, rawSearch, recordBounce } from "@/lib/oauth"
import { OAuthExpired, OAuthShell } from "./oauth-consent"

/**
 * /oauth/continue?<signed query> (external MCP spec §6.1): the authorization server's login page. The route sends a
 * signed-out person to sign-in first (and back here with a full page load); with a session this page re-runs the
 * client's authorize request without the provider's signing params. A full page load: authorize is a Worker route.
 */
export function OAuthContinuePage() {
  const searchStr = useLocation({ select: (l) => l.searchStr })
  const target = authorizeUrl(rawSearch(OAUTH_CONTINUE_PATH, searchStr))
  const started = useRef(false)
  const [looping, setLooping] = useState(false)

  useEffect(() => {
    if (!target || started.current) return
    started.current = true
    if (!recordBounce()) return setLooping(true)
    window.location.assign(target)
  }, [target])

  if (!target)
    return (
      <OAuthShell>
        <OAuthExpired />
      </OAuthShell>
    )
  if (looping)
    return (
      <OAuthShell>
        <OAuthExpired detail="Minga keeps asking you to sign in for this app. Sign out and in again, then start the connection again from the app you were connecting." />
      </OAuthShell>
    )
  return (
    <OAuthShell>
      <CardTitle>Connecting to Minga…</CardTitle>
      <p className="mt-2 text-sm text-muted">You're signed in. Taking you to the next step.</p>
    </OAuthShell>
  )
}
